query getCompanyAutoRepliedStatistics($input: CompanyEmailFunnelsBounceInput) {
    emailAutoReplyStatistics: getCompanyAutoRepliedStatistics(input: $input) {
        totalCount
        bounces {
            type
            date
        }
    }
}
